import React, { useEffect } from "react";
import { UserInterface } from "src/store/callrecorder/usersSlice";

import { Button, Form, Input, InputNumber, Switch } from "antd";

interface propsInterface {
  params?: UserInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={{
        verified: false,
        suspicious: false,
        ads: false,
        rec: false,
        ...params,
      }}
    >
      <h6 className="v-content-label o-sm">Contact</h6>

      <Form.Item name='cnumber' label="Calling Number">
        <Input placeholder='+15551234567' />
      </Form.Item>

      <h6 className="v-content-label o-sm">Account</h6>

      <Form.Item name='balance' label="Balance">
        <InputNumber placeholder='0.0' style={{ width: '100%' }} step={0.01} />
      </Form.Item>

      <Form.Item label="Verified" name='verified' valuePropName='checked'>
        <Switch checkedChildren='yes' unCheckedChildren='no' />
      </Form.Item>

      <Form.Item label="Suspicious" name='suspicious' valuePropName='checked'>
        <Switch checkedChildren='yes' unCheckedChildren='no' />
      </Form.Item>

      <Form.Item label="Ads" name='ads' valuePropName='checked'>
        <Switch checkedChildren='yes' unCheckedChildren='no' />
      </Form.Item>

      <Form.Item label="Recording" name='rec' valuePropName='checked'>
        <Switch checkedChildren='yes' unCheckedChildren='no' />
      </Form.Item>

      <h6 className="v-content-label o-sm">Settings</h6>

      <Form.Item name='voice_changer' label="Voice Changer">
        <InputNumber placeholder='1.0' style={{ width: '100%' }} step={0.1} />
      </Form.Item>

      <Form.Item name='bundle_id' label="Bundle ID">
        <InputNumber placeholder='1' style={{ width: '100%' }} min={0} />
      </Form.Item>

      <Form.Item name='provider_id' label="Provider ID">
        <InputNumber placeholder='1' style={{ width: '100%' }} min={0} />
      </Form.Item>

      <Form.Item name='bg_noise_id' label="BG Noise ID">
        <InputNumber placeholder='1' style={{ width: '100%' }} min={0} />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
